import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const ASANA_FORM_URL =
  'https://form.asana.com/?k=OKCsOEte-p6k1sUtDAl6Mg&d=280257083226273'

const FeedbackChoiceModal = ({ show, onHide, onOpenFeedbackForm }) => {
  const handleSupportRequest = () => {
    window.open(ASANA_FORM_URL, '_blank')
    onHide()
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center">Segnalazione</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="py-3 text-center">
          <Button
            variant="outline-primary"
            size="lg"
            className="mb-3 mx-auto"
            style={{ width: '350px', display: 'block' }}
            onClick={handleSupportRequest}
          >
            Richiesta di supporto
          </Button>
          <Button
            variant="outline-primary"
            size="lg"
            className="mx-auto"
            style={{ width: '350px', display: 'block' }}
            onClick={onOpenFeedbackForm}
          >
            Inserisci feedback
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default FeedbackChoiceModal
